import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import classNames from "classnames";
import styles from "./index.css";
import addUpSellCarousel from "../../../addUpSellCarousel";
import addAdvert from "../../../addAdvert";
import getFocusTileIndex from "../../../getFocusTileIndex";
import mapProductsToProductTiles from "../../../mapProductsToProductTiles";
import addCategoryPreviews from "../../../addCategoryPreviews";
import addLoyaltyMembersDayBanner from "../../../addLoyaltyMembersDayBanner";
import addLoyaltyEarlyAccessSaleBanner from "../../../addLoyaltyEarlyAccessSaleBanner";
import getAdditionalItemPositionFinder from "../../../getAdditionalItemPositionFinder";
import { getClientWidth } from "../../../../../state/modules/layout/selectors";
import getGridExpansionLayout from "./getGridExpansionLayout";
import hasCuratedElevatedProductTiles from "./hasCuratedElevatedProductTiles";

const ListingPage = ({
  isInitialPage,
  page: { products, pageNumber },
  focusFirstTile,
  focusLastTile,
  advert,
  upSellCarousel,
  treatments,
  viewportCategory,
  ...rest
}) => {
  const positionFinder = useSelector(getAdditionalItemPositionFinder);
  const clientWidth = useSelector(getClientWidth);
  const useOriginalCuratedGrid = hasCuratedElevatedProductTiles(treatments);
  const { viewportCategory: gridViewportCategory } = getGridExpansionLayout({
    clientWidth,
    hasCuratedElevatedProductTiles: useOriginalCuratedGrid,
    viewportCategory,
  });
  const focusTileIndex = getFocusTileIndex({
    focusFirstTile,
    focusLastTile,
    products,
  });

  const initialProductsTilesArray = mapProductsToProductTiles({
    products,
    focusTileIndex,
    isInitialPage,
    pageNumber,
    ...rest,
  });

  let items = [...initialProductsTilesArray];

  const getAdditionalItemPosition = positionFinder({
    products,
    productTiles: initialProductsTilesArray,
    viewportCategory: gridViewportCategory,
  });

  items = addAdvert({
    advert,
    items,
    positionFinder: getAdditionalItemPosition,
  });

  items = addUpSellCarousel({
    upSellCarousel,
    items,
    positionFinder: getAdditionalItemPosition,
  });

  if (pageNumber === 1) {
    items = addCategoryPreviews({
      treatments,
      positionFinder: getAdditionalItemPosition,
      items,
      viewportCategory: gridViewportCategory,
    });
  }

  if (pageNumber === 1) {
    items = addLoyaltyMembersDayBanner({
      viewportCategory: gridViewportCategory,
      positionFinder: getAdditionalItemPosition,
      items,
    });
  }

  if (pageNumber === 1) {
    items = addLoyaltyEarlyAccessSaleBanner({
      viewportCategory: gridViewportCategory,
      positionFinder: getAdditionalItemPosition,
      items,
    });
  }

  return (
    <ul
      className={classNames(styles.listingPage, {
        [styles.curatedListingPage]: useOriginalCuratedGrid,
      })}
      data-auto-id={pageNumber}
      data-testid={`listing-results-${pageNumber}`}
    >
      {items}
    </ul>
  );
};

ListingPage.propTypes = {
  isInitialPage: PropTypes.bool.isRequired,
  page: PropTypes.shape({
    products: PropTypes.arrayOf(PropTypes.object).isRequired,
    pageNumber: PropTypes.number,
  }),
  focusFirstTile: PropTypes.bool.isRequired,
  focusLastTile: PropTypes.bool.isRequired,
  advert: PropTypes.func,
  upSellCarousel: PropTypes.func,
  treatments: PropTypes.object,
  viewportCategory: PropTypes.string,
};

export default ListingPage;
